import { useMemo } from 'react';

interface LogoProps {
  size?: 'sm' | 'md' | number;
}

export function Logo({ size = 'md' }: LogoProps) {
  const imageHeight = useMemo(() => {
    if (size === 'sm') {
      return 62;
    }
    if (size === 'md') {
      return 120;
    }

    return size;
  }, [size]);

  return (
    <div className="flex justify-center items-center">
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src="/logo.svg"
        alt="Enluma Consult+ Logo"
        width={0}
        height={imageHeight}
        style={{ width: 'auto', height: `${imageHeight}px` }}
        className={'object-contain'}
      />
    </div>
  );
}
